import Knock from '@knocklabs/client';

import { env } from 'config';

import API from 'utils/api';

let knockClient: Knock | null = null;
let authPromise: Promise<boolean> | null = null;

export function getKnockClient(): Knock {
  if (!knockClient) {
    const apiKey = env.REACT_APP_KNOCK_PUBLIC_API_KEY;
    if (!apiKey) {
      throw new Error('Missing REACT_APP_KNOCK_PUBLIC_API_KEY environment variable');
    }
    knockClient = new Knock(apiKey);
  }
  return knockClient;
}

async function doAuthenticateKnockClient(): Promise<boolean> {
  const { data } = await API.user.getKnockToken()();
  if (!data.enabled || !data.token || !data.userId) {
    return false;
  }
  getKnockClient().authenticate({ id: data.userId }, data.token, {
    onUserTokenExpiring: async () => {
      const { data: refreshed } = await API.user.getKnockToken({ background: true })();
      return refreshed.token ?? undefined;
    },
  });
  return true;
}

export function authenticateKnockClient(): Promise<boolean> {
  if (!authPromise) {
    authPromise = doAuthenticateKnockClient().catch((e) => {
      authPromise = null;
      throw e;
    });
  }
  return authPromise;
}

export function resetKnockClient(): void {
  if (knockClient) {
    knockClient.teardown();
  }
  knockClient = null;
  authPromise = null;
}
